import { TypographySubtle } from '@seen/ui'
import type { JSX, ReactNode } from 'react'

export interface ValidatedToolSectionProps {
  title: string
  subtitle?: ReactNode
  children: ReactNode
}

export function ValidatedToolSection({
  title,
  subtitle,
  children,
}: ValidatedToolSectionProps): JSX.Element {
  return (
    <div className="flex flex-col gap-2">
      <div className="flex flex-col gap-1">
        <h2>{title}</h2>
        {!!subtitle && (
          <TypographySubtle className="text-foreground-secondary">
            {subtitle}
          </TypographySubtle>
        )}
      </div>
      {children}
    </div>
  )
}
